/**
 * Created by razial on 21.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.WoodenKrakenFeastWindow, {
    person: {
        left: {
            role: "king"
        }
    }
});
